import {
  FeeCalculationBasis,
  FeeType,
  CoreFeeType,
} from 'further-types/investment';

const lookupDisplayFeeType = (
  feeType: FeeType,
  feeCalculationBasis: FeeCalculationBasis,
) => {
  const isInitial = feeType === FeeType.Initial;
  const isPercentage =
    feeCalculationBasis === FeeCalculationBasis.PercentageOfTotalCommitment ||
    feeCalculationBasis === FeeCalculationBasis.PercentageOfUnrealisedAssetCost;

  if (isInitial && isPercentage) {
    return CoreFeeType.InitialPercentage;
  } else if (isInitial && !isPercentage) {
    return CoreFeeType.InitialFixed;
  } else if (!isInitial && isPercentage) {
    return CoreFeeType.RecurringPercentage;
  } else {
    return CoreFeeType.RecurringFixed;
  }
};

export default lookupDisplayFeeType;
